import React from 'react';
import { TBuyWaitResults } from '../../../../types/api';
import { DetailText, DetailTextCenter, HtmlDollarPercent, RowMessage } from '../../../atoms';

interface Props {
  results: TBuyWaitResults;
}

const BuyWait: React.FC<Props> = ({ results: { aCalc, aNotes } }) => {
  // const { currentSettings } = useContext(UiSettingsProviderContext);

  console.log('aNotes', aNotes);
  console.log('buyWaitReport->', aCalc);
  return (
    <table className="table">
      <tbody>
        <tr>
          <DetailText v="Report Type" />
          {aCalc && <DetailTextCenter v={aCalc.report_type} />}
          {aCalc && <DetailTextCenter v={aCalc.report_type_2} />}
        </tr>
        <tr className="active-row">
          <RowMessage v={3} prompt="Purchase Details" />
        </tr>
        <tr>
          <DetailText v="Purchase Price" />
          {aCalc && <DetailTextCenter v={aCalc.sp.toString()} />}
          {aCalc && <DetailTextCenter v={aCalc.sp_2.toString()} />}
        </tr>
        <tr>
          <DetailText v="Base Loan Amount" />
          {aCalc && <DetailTextCenter v={aCalc.ma.toString()} />}
          {aCalc && <DetailTextCenter v={aCalc.ma_2.toString()} />}
        </tr>
        <tr>
          <DetailText v="Total Loan Amount" />
          {aCalc && <DetailTextCenter v={aCalc.total_mtge.toString()} />}
          {aCalc && <DetailTextCenter v={aCalc.total_mtge_2.toString()} />}
        </tr>
        <tr>
          <DetailText v="Down Payment" />
          {aCalc && <DetailTextCenter v={aCalc.d_payment.toString()} />}
          {aCalc && <DetailTextCenter v={aCalc.d_payment_2.toString()} />}
        </tr>
        <tr>
          <DetailText v="Total Closing Cost" />
          {aCalc && <DetailTextCenter v={aCalc.totalcc.toString()} />}
          {aCalc && <DetailTextCenter v={aCalc.totalcc_2.toString()} />}
        </tr>
        <tr>
          <DetailText v="Closing Cost Credit" />
          {aCalc && <HtmlDollarPercent a={aCalc.dol_cred.toString()} b={aCalc.temp_cred.toString()} />}
          {aCalc && <HtmlDollarPercent a={aCalc.dol_cred_2.toString()} b={aCalc.temp_cred_2.toString()} />}
        </tr>
        <tr>
          <DetailText v="Required Cash" />
          {aCalc && <DetailTextCenter v={aCalc.r_cash.toString()} />}
          {aCalc && <DetailTextCenter v={aCalc.r_cash_2.toString()} />}
        </tr>
        <tr className="active-row">
          <RowMessage v={3} prompt="Payment Details" />
        </tr>
        <tr>
          <DetailText v="Interest Rate" />
          {aCalc && <DetailTextCenter v={aCalc.temp_rate.toString()} />}
          {aCalc && <DetailTextCenter v={aCalc.temp_rate_2.toString()} />}
        </tr>
        <tr>
          <DetailText v="Total Monthly Payment" />
          {aCalc && <DetailTextCenter v={aCalc.t_piti.toString()} />}
          {aCalc && <DetailTextCenter v={aCalc.t_piti_2.toString()} />}
        </tr>
        <tr>
          <DetailText v="Principal &amp; Interest" />
          {aCalc && <DetailTextCenter v={aCalc.temp_pi.toString()} />}
          {aCalc && <DetailTextCenter v={aCalc.temp_pi_2.toString()} />}
        </tr>
        <tr>
          <DetailText v="Monthly Mortgage Insurance" />
          {aCalc && <DetailTextCenter v={aCalc.temp_mi.toString()} />}
          {aCalc && <DetailTextCenter v={aCalc.temp_mi_2.toString()} />}
        </tr>
        <tr>
          <DetailText v="Monthly Property Taxes" />
          {aCalc && <DetailTextCenter v={aCalc.temp_pt.toString()} />}
          {aCalc && <DetailTextCenter v={aCalc.temp_pt_2.toString()} />}
        </tr>
        <tr>
          <DetailText v="Monthly Property Insurance" />
          {aCalc && <DetailTextCenter v={aCalc.temp_ins.toString()} />}
          {aCalc && <DetailTextCenter v={aCalc.temp_ins_2.toString()} />}
        </tr>
        <tr>
          <DetailText v="Monthly Condo/HOA Fee" />
          {aCalc && <DetailTextCenter v={aCalc.condo.toString()} />}
          {aCalc && <DetailTextCenter v={aCalc.condo_2.toString()} />}
        </tr>
        <tr className="active-row">
          <RowMessage v={3} prompt="Tax Considerations" />
        </tr>
        <tr>
          <DetailText v="Estimated Annual Tax Deduction" />
          {aCalc && <DetailTextCenter v={aCalc.tot_duct.toString()} />}
          {aCalc && <DetailTextCenter v={aCalc.tot_duct_2.toString()} />}
        </tr>
        <tr>
          <DetailText v="Federal Tax Bracket" />
          {aCalc && <DetailTextCenter v={aCalc.print_t_bracket.toString()} />}
          {aCalc && <DetailTextCenter v={aCalc.print_t_bracket.toString()} />}
        </tr>
        <tr>
          <DetailText v="Monthly Federal Tax Savings" />
          {aCalc && <DetailTextCenter v={aCalc.tax_saving.toString()} />}
          {aCalc && <DetailTextCenter v={aCalc.tax_saving_2.toString()} />}
        </tr>
        <tr>
          <DetailText v="Net Monthly Mortgage Payment" />
          {aCalc && <DetailTextCenter v={aCalc.net_mort_pay.toString()} />}
          {aCalc && <DetailTextCenter v={aCalc.net_mort_pay_2.toString()} />}
        </tr>
        <tr>
          <DetailText v="Potential Equity" />
          {aCalc && <DetailTextCenter v={aCalc.net_equity.toString()} />}
          {aCalc && <DetailTextCenter v={aCalc.net_equity_2.toString()} />}
        </tr>
        <tr>
          <RowMessage v={3} prompt="" />
        </tr>
        <tr>
          <RowMessage v={3} prompt="Christee Report for Buy Today or Wait" />
        </tr>
        <tr>
          <RowMessage v={3} prompt={aCalc.m_note.toString()} />
        </tr>
        <tr>
          <RowMessage v={3} prompt={aCalc.m_note1.toString()} />
        </tr>
        <tr>
          <RowMessage v={3} prompt={aCalc.m_note2.toString()} />
        </tr>
        <tr>
          <RowMessage v={3} prompt={aCalc.m_note3.toString()} />
        </tr>
        <tr>
          <RowMessage v={3} prompt={aCalc.m_note4.toString()} />
        </tr>
        <tr>
          <RowMessage v={3} prompt={aCalc.m_note5.toString()} />
        </tr>
      </tbody>
    </table>
  );
};

export default BuyWait;
